import { cn } from 'lib/helpers/utility';
import { PAYMENT_METHOD_FIELDS } from 'lib/constants/healthcareProgram/paymentSetup';
import { paymentMethods } from 'lib/constants/healthcareProgram/defaultPaymentSetup';

import Icon from 'components/shared/Icon/Icon';
import Badge from 'components/shared/Badge/Badge';
import Typography from 'components/shared/Typography/Typography';

const PREVIEW_FIELDS = [
  PAYMENT_METHOD_FIELDS.CREDIT_DEBIT_CARD,
  PAYMENT_METHOD_FIELDS.ACH,
  PAYMENT_METHOD_FIELDS.PRE_AUTH
];

const previewMethods = PREVIEW_FIELDS.map((field) =>
  paymentMethods.find((method) => method.field === field)
).filter(Boolean);

// Static stand-in for the `Disclosure` rows rendered by the check-in `PaymentMethods` list.
const CheckinPaymentOptions = ({ isNarrow = false }) => (
  <div className="flex flex-col gap-4">
    {previewMethods.map((method) => (
      <div
        key={method.field}
        className="flex items-center gap-3 rounded-xl border border-solid border-neutral-300 bg-white py-3 pl-4 pr-5">
        <span
          className={cn(
            'flex h-10 w-10 shrink-0 items-center justify-center rounded-full',
            method.iconBackground
          )}>
          <Icon icon={method.icon} color={method.iconColor} shade={method.iconShade} size={24} />
        </span>
        <div className="flex min-w-0 flex-1 flex-col gap-0.5">
          {isNarrow && method.recommended && (
            <Badge
              text="recommended"
              size="small"
              color="primary"
              variant="light"
              className="mb-1 w-fit"
            />
          )}
          <Typography variant="label" size="medium" weight="medium">
            {method.title}
          </Typography>
          <Typography variant="p" size="xs" color="neutral-700" className="block">
            {method.description}
          </Typography>
        </div>
        {!isNarrow && method.recommended && (
          <Badge
            text="recommended"
            size="small"
            color="primary"
            variant="light"
            className="shrink-0"
          />
        )}
        <Icon icon="arrow-right-linear" className="shrink-0" />
      </div>
    ))}
  </div>
);

export default CheckinPaymentOptions;
